module.exports = __webpack_public_path__ + "static/media/success-icon-monarch.0d36d082.svg";